import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import Transparent from '../images/sprite/transparent.gif';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import sexyAe from '../images/casino/aesexy.webp'
import roulletee from '../images/casino/ezugi.webp'
// import Mojo from '../images/Banner/mojos.jpg'
import blackjack from '../images/casino/Blackjack.webp'
import Loading from "../images/sprite/loading40.gif"
import img1 from '../images/headerlogo.png'
import patti20 from '../images/casino/teenpatti.jpeg'
// import Banneryc from '../images/Banner/Horse_Racing_page-0001.jpg';
// import Binary from '../images/Banner/Binary_page-0001.jpg'
// import Lucky7 from '../images/banner_betgames-half.png';
import colorgame from '../images/casino/colorgame.jpeg'
// import rummyjpg from '../images/Banner/rummy.jpg'
import Sports from '../images/Banner/bannersports.webp';
import numbermatka from '../images/casino/numbermatka.jpeg'
// import kabaddi from '../images/Banner/kabaddi_page.jpg'
import Kings1 from '../images/casino/7updown.webp'
// import Kifngs2 from '../images/casino/Blackjack.jpeg'
// import anderbahar from '../images/casino/Andar-Bahar.webp'
import mineswiper from '../images/casino/mineswiper.jpeg'
import Kings5 from '../images/casino/sicbokm.jpeg'
import Kings6 from '../images/kv/CoinToss.png'
import Kings7 from '../images/kv/europeanroulette.jpeg'
import Kings8 from '../images/kv/cardMatka.png'
import Cookies from 'universal-cookie';
import Evolutiongame from '../images/casino/evo.jpeg'
// import birdfight from '../images/Banner/birdfight.jpeg'
import ludo from '../images/kv/ludo.png'
// import Womnesbanner from '../images/Banner/womensBanner.jpeg'
// import andarbahar from '../images/Banner/andarbahar.jpeg'
import NumberMatka from '../images/casino/numbermatka.jpeg'
// import Matka from '../images/casino/cardmatka.jpeg'
// import IPL from '../images/Banner/ipl.jpeg'
// import IPL2 from '../images/Banner/ipl2023.webp'

const cookies = new Cookies();

const photos = [
    // {
    //     name: 'photo 1',
    //     url: [IPL]
    // },
    // {
    //     name: 'photo 2',
    //     url: [IPL2]
    // },
    // {
    //     name: 'photo 3',
    //     url: [Womnesbanner]
    // },
    // {
    //     name: 'photo 7',
    //     url: [Matka]
    // },
    // {
    //     name: 'photo 8',
    //     url: [NumberMatka]
    // },
    // {
    //     name: 'photo 9',
    //     url: [andarbahar]
    // }


]

const settings = {
    dots: true,
    slide: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 800,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    className: 'slidesN'
}

export default function Bannerpage(props) {
    const [Socialicon, setSocialicon] = useState(1);
    const [countCricket, setCountCricket] = useState(0);
    const [countSoccer, setCountSoccer] = useState(0);
    const [countTennis, setCountTennis] = useState(0);
    const [casinoWait, setcasinoWait] = useState(false);
    const [getBanners, setBanners] = useState([])

    const history = useHistory();

    function changecount(cri, socc, tenn) {

        setCountCricket(cri);
        setCountSoccer(socc);
        setCountTennis(tenn);
    }

    // Fetch Sites Banner
    const getBannerSiteImages = async () => {
        try {
            let resp = await axios.post(
                'https://luckybdt.live/clientapi/getBanner',
                {
                    siteName: 'LEBUZZADMIN'
                }
            );
            if (resp) {
                // cosnsole.log(resp.data)
                if (resp.status == 200) {
                    return resp.data;
                }
                return false;
            }
        } catch (error) {
            return false;
        }
    }

    useEffect(async () => {
        setBanners(photos);
        let val = await getBannerSiteImages();
        if (val.length > 0) {
            let newResp = [{ url: val[0].banner1 }, { url: val[0].banner2 }, { url: val[0].banner3 }, { url: val[0].banner4 }, { url: val[0].banner5 }, { url: val[0].banner6 }, { url: val[0].banner7 }, { url: val[0].banner8 }, { url: val[0].banner9 }, { url: val[0].banner10 }]
            setBanners(newResp)
        }
    }, []);


    useEffect(() => {
        axios.all([
            axios.get('https://luckybdt.live/clientapi/cricket'),
            axios.get('https://luckybdt.live/clientapi/soccer'),
            axios.get('https://luckybdt.live/clientapi/tennis')
        ])
            .then(axios.spread((obj1, obj2, obj3) => {


                var count1 = 0;
                var count2 = 0;
                var count3 = 0;

                obj1.data.map(item => {
                    item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
                    return item;
                })

                obj2.data.map(item => {
                    item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
                    return item;
                })
                obj3.data.map(item => {
                    item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
                    return item;
                })

                obj1.data.map((item) => {
                    if (moment() >= moment(item.marketStartTime)) {
                        count1 = count1 + 1;
                    }
                });
                obj2.data.map((item) => {
                    if (moment() >= moment(item.marketStartTime)) {
                        count2 = count2 + 1;
                    }
                });
                obj3.data.map((item) => {
                    if (moment() >= moment(item.marketStartTime)) {
                        count3 = count3 + 1;
                    }
                });
                changecount(count1, count2, count3);
            }));
    }, [])

    return (
        <React.Fragment>

            {casinoWait === true &&
                <ul class="loading">
                    <li><img src={Loading} /></li>
                    <li>Loading...
                    </li>
                    <br />
                    <li><span id="progress"></span></li>
                </ul>

            }
            {/* { casinoWait && <div class="bl-Preloader" id="__-plContainer">
         <div class="bl-Preloader_Header">
           <div class="bl-Preloader_ProductHeader "></div>
               <div class="bl-Preloader_MainHeader ">
            <div class="bl-Preloader_MainHeaderLogo "></div>
           </div>
          </div>
         <div class="bl-Preloader_SpinnerContainer ">
           <div class="bl-Preloader_Spinner "></div>
         </div>
       </div> } */}

            {/* <div class="bl-Preloader" id="__-plContainer">
    <div class="bl-Preloader_Header">
        <div class="bl-Preloader_ProductHeader "></div>
        <div class="bl-Preloader_MainHeader ">
            <div class="bl-Preloader_MainHeaderLogo "></div>
        </div>
    </div>
    <div class="bl-Preloader_SpinnerContainer ">
        <div class="bl-Preloader_Spinner "></div>
    </div>
</div> */}
            {/* <div class="overlay" style={{display: "flex",justifyContent:'center',alignItems:'center',backgroundColor:'rgb(0 0 0 / 90%)'}}>  
                            <div id="page-wrap">
                    <div class="meter red">
                        <span style={{width: "100%"}}></span>
                    </div>
                        </div>
                        </div> */}


            <div _ngcontent-lst-c68="" id="centerColumn" class="centar-content casinozone">

                <div _ngcontent-lst-c68="" id="overWrap" class="lit-content-center" style={{ height: "calc(100% - 0px)" }}>
                    <div _ngcontent-lst-c68="" class="images-grid">
                        <Slider  {...settings}>
                            {getBanners.filter((x, i) => x.url !== null).map((photo, id) => {
                                return (
                                    <div key={id}>
                                        <img src={photo.url} alt="cric" style={{ height: '192px' }} />
                                    </div>
                                )
                            })}
                        </Slider>
                    </div>
                    <div _ngcontent-lst-c68="" class="casinozone-wrap-simple">
                        <a _ngcontent-lst-c68="" href="/" style={{ cursor: "pointer" }}>
                            <dl _ngcontent-lst-c68="" id="onLiveBoard" class="live_events">
                                <dt _ngcontent-lst-c68="" >
                                    <p _ngcontent-lst-c68="" class="live_icon"><span></span> LIVE</p>
                                </dt>

                                <dd _ngcontent-lst-c68="" id="onLiveCount_CRICKET">
                                    <p _ngcontent-lst-c68="" >Cricket</p><span id="count">{countCricket}</span></dd>

                                <dd _ngcontent-lst-c68="" id="onLiveCount_SOCCER">
                                    <p _ngcontent-lst-c68="" >Soccer</p><span id="count">{countSoccer}</span></dd>

                                <dd _ngcontent-lst-c68="" id="onLiveCount_TENNIS">
                                    <p _ngcontent-lst-c68="" >Tennis</p><span id="count">{countTennis}</span></dd>

                            </dl>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Sports</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Sports} alt="" draggable="false" />
                        </a>



                        <a _ngcontent-lst-c68="" style={{ cursor: "pointer" }} href={props.isLoggedIn ? '/game-play/S2/LC/AWC Sexy/0' : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Ae Sexy</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={sexyAe} alt="" draggable="false" />
                        </a>


                        <a _ngcontent-lst-c68="" style={{ gridColumn: 'span 2' }} href={props.isLoggedIn ? "/game-play/GE/LC/Gaming Evolution/0" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Evolution Gaming</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Evolutiongame} alt="" draggable="false" />
                        </a>
                        <a _ngcontent-lst-c68="" style={{ gridColumn: 'span 2' }}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Ludo</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={ludo} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Sicbo" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Sicbo</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Kings5} alt="" draggable="false" />
                        </a>
                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_7_Up_7_Down" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >7 Up 7 Down</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Kings1} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Coin_Toss" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Coin Toss</dt>
                                <dd _ngcontent-lst-c68="" >Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Kings6} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Triple_Chance" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt>Number Matka</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={numbermatka} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Poker_Roulette" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt>Card Matka</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={Kings8} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Andar_Bahar" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt>Ander Bahar</dt>
                                <dd>Play Now</dd>
                            </dl>
                            {/* <img _ngcontent-lst-c68="" src={anderbahar} alt="" draggable="false" /> */}
                        </a>
                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Blackjack" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt _ngcontent-lst-c68="" >Blackjack</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={blackjack} alt="" draggable="false" />
                        </a>
                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/EZ/LC/Ezugi/0" : '/'}>
                            <dl _ngcontent-lst-c68="" class="casino-title">
                                <dt>Ezugy</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img _ngcontent-lst-c68="" src={roulletee} alt="" draggable="false" />
                        </a>
                        {/* <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }}>
                            <dl class="casino-title">
                                <dt>7 Mojos</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={Mojo} alt="" draggable="false" />
                        </a> */}


                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? '/game-play/RE/SL/KingMakers/KMQM_Minesweeper' : '/'}>
                            <dl class="casino-title">
                                <dt>mine Swiper</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={mineswiper} alt="" draggable="false" />
                        </a>

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? '/game-play/JJ/SL/Teenpatti/161' : '/'}>
                            <dl class="casino-title">
                                <dt>TeenPatti 20-20</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={patti20} alt="" draggable="false" />
                        </a>
                        {/* <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }}>
                            <dl class="casino-title">
                                <dt>Binary</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={Binary} alt="" draggable="false" />
                        </a> */}
                        {/* <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }}>
                            <dl class="casino-title">
                                <dt>Betgames</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={Lucky7} alt="" draggable="false" />
                        </a> */}
                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_Color_Game" : '/'}>
                            <dl class="casino-title">
                                <dt>Color Game</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={colorgame} alt="" draggable="false" />
                        </a>
                        {/* <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }}>
                            <dl class="casino-title">
                                <dt>Rummy</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={rummyjpg} alt="" draggable="false" />
                        </a> */}

                        <a _ngcontent-lst-c68="" class="mob-casino-half" style={{ cursor: "pointer" }} href={props.isLoggedIn ? "/game-play/RE/SL/KingMakers/KMQM_European_Roulette" : '/'}>
                            <dl class="casino-title">
                                <dt>Roulette</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={Kings7} alt="" draggable="false" />
                        </a>

                        {/* <a style={{ cursor: "pointer", cursor: "pointer", height: '255px' }}>
                            <dl class="casino-title">
                                <dt>Horse Racing</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={Banneryc} alt="" draggable="false" />
                        </a> */}

                        {/* <a style={{ cursor: "pointer", cursor: "pointer", height: '255px' }}>
                            <dl class="casino-title">
                                <dt>Kabaddi</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={kabaddi} alt="" draggable="false" />
                        </a> */}








                        {/* <a style={{ cursor: "pointer", gridColumn: "span 4", height: '187px' }}>
                            <dl class="casino-title">
                                <dt>Bird Fight</dt>
                                <dd>Play Now</dd>
                            </dl>
                            <img src={birdfight} alt="" draggable="false" />
                        </a> */}
                    </div>

                    <div _ngcontent-lst-c68="" class="footer" >


                        <div id="supportWrap" className="support-wrap">
                            <div className="support-service">
                                <a id="support_email" onMouseOver={() => { setSocialicon(0) }} className={`support-mail  ${(Socialicon === 0) ? "open" : "null"}`} >
                                    <img src={Transparent} title="Email" /></a>
                                <a id="support_whatsapp" onMouseOver={() => { setSocialicon(1) }} className={`support-whatsapp  ${(Socialicon === 1) ? "open" : "null"}`} >
                                    <img src={Transparent} title="WhatsApp" /></a>
                                <a
                                    id="support_telegram" onMouseOver={() => { setSocialicon(2) }} className={`support-telegram  ${(Socialicon === 2) ? "open" : "null"}`} >
                                    <img src={Transparent} title="Telegram" /></a>
                                <a id="support_email" onMouseOver={() => { setSocialicon(3) }} className={`support-skype  ${(Socialicon === 3) ? "open" : "null"}`} >
                                    <img src={Transparent} title="skype" /></a>
                                <a
                                    id="support_email" onMouseOver={() => { setSocialicon(4) }} className={`support-ig  ${(Socialicon === 4) ? "open" : "null"}`} >
                                    <img src={Transparent} title="skype" /></a>
                            </div>
                            <div className="support-info">
                                <div id="supportDetail_telegram" className="support-detail open">
                                    {Socialicon === 1 && <a className="ui-link" href="+601140563496">
                                        <span style={{ color: 'rgb(102, 102, 102)', textDecoration: 'underline' }} />+601140563496</a>}
                                    {Socialicon === 2 && <a className="ui-link" href="https://t.me/bajie365">
                                        <span style={{ color: 'rgb(102, 102, 102)', textDecoration: 'underline' }} />bajie365</a>}
                                </div>
                            </div>
                        </div>

                        <div class="power-content" style={{ width: "109px" }}>
                            <h3 _ngcontent-lst-c68="" style={{ backgroundImage: 'none', lineHeight: '15px', color: '#484745', marginTop: '-5px', textAlign: 'left' }}><span>Powered by</span><img src={Transparent} alt="poweredby" /></h3>
                        </div>
                        <div _ngcontent-lst-c68="" class="browser-footer-content">

                            <img _ngcontent-lst-c68="" src={Transparent} alt="gif" />
                            <br></br>
                            Our website works best in the newest and last prior version of these browsers: <br></br>Google Chrome.
                        </div>


                        <ul _ngcontent-lst-c68="" className="mob-inform-link">
                            <li _ngcontent-lst-c68=""  ><a >KYC</a></li>
                            <li _ngcontent-lst-c68=""  ><a >About Us</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Privacy Policy</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Responsible Gaming</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Terms and Conditions</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Underage Gaming Policy</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Self-Exclusion Policy</a></li>
                            <li _ngcontent-lst-c68=""  ><a >Rules and Regulations</a></li>









                        </ul>


                        <ul _ngcontent-lst-c68="" class="RnR-link">
                            <li _ngcontent-lst-c68=""><a >Rules and Regulations</a></li>
                        </ul>
                    </div>
                </div>

            </div>

        </React.Fragment>
    )
}
